var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},_vm._l((_vm.tagMsg),function(msg,key){return _c('el-alert',{key:key,staticClass:"base-alert",attrs:{"show-icon":"","visible":msg.content!='',"type":msg.color,"closable":msg.closable=='1',"data-suda":msg.suda,"title":""}},[_c('div',{staticClass:"zz-alert",domProps:{"innerHTML":_vm._s(msg.content)}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0fd8e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = null
// module chunks = 